import React, { Fragment } from 'react'
import styles from './Producto.module.css'

const ProductoCard = ({ producto }) => {

  function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  return (
    <Fragment>
      <div className={styles['areaproducto']}>
        <div className={styles['productoapice']}></div>
        <div className={styles['productoinfo']}>
          <p>{producto.nombreProducto}</p>
          <div className={styles['productoinfo_title']}>
            <div className={styles['productoinfo_detalle_area1']}>
              <p>Frecuencia de pago</p>
              <span>{producto.frecuenciaPago.descripcion}</span>
            </div>
            <div className={styles['productoinfo_detalle_area2']}>
              <p>Prima total</p>
              <span>{`${producto.simboloMoneda} ${producto.primaTotal.toLocaleString('en-US', {minimumFractionDigits : 2})}`}</span>
            </div>
            <div className={styles['productoinfo_detalle_area3']}>
              <p>Suma asegurada</p>
              <span>
                {`${producto.simboloMoneda} 
                ${producto.sumaAsegurada.toLocaleString('en-US', {minimumFractionDigits : 2})}`}
              </span>
            </div>
          </div>
          <div className={styles['productoinfo_detalle']}>
            <div className={styles['productoinfo_detalle_area1']}>
              {producto.informacionExtra.map((item, i) => (
                <p className={`${styles['area100']} ${styles['txtsumaseg2']}`} key={i}>
                  {item.etiqueta}
                  <br /> 
                  <span className={styles['area69']}>{item.descripcion}</span>
                </p>
              ))}
            </div>
            <div className={styles['productoinfo_detalle_area2']}>
              <p className={`${styles['txtsumaseg']}`}>Resumen de pago</p>
              <p className={styles['txtsumaseg']}>
                <strong>Prima Comercial</strong>
                <span className={styles['area69']}>
                  {`${producto.simboloMoneda} 
                  ${producto.primaComercial.toLocaleString('en-US', {minimumFractionDigits : 2})}`}
                </span>
              </p>
              <p className={styles['txtsumaseg']}>
                <strong>Prima Excedentes</strong>
                <span className={styles['area69']}>
                  {`${producto.simboloMoneda} 
                  ${producto.primaExcedente.toLocaleString('en-US', {minimumFractionDigits : 2})}`}
                </span>
              </p>
              <p className={styles['txtsumaseg']}>
                <strong>IGV</strong>
                <span className={styles['area69']}>
                  {`${producto.simboloMoneda} 
                   ${producto.igv.toLocaleString('en-US', {minimumFractionDigits : 2})}`}
                </span>
              </p>
              <p className={`${styles['txtcobertura_item2']} ${styles['txtprimatotal']}`} style={{justifyContent: "space-between"}}>
                <strong style={{width: '69%'}}>Prima Total</strong>
                <span className={styles['area69']}>
                  {`${producto.simboloMoneda} 
                  ${producto.primaTotal.toLocaleString('en-US', {minimumFractionDigits : 2})}`}
                </span>
              </p>
            </div>
            <div>
              <p className={styles['txtcoberturas']}>Coberturas</p>
              {producto.coberturas
                ? removeDuplicates(producto.coberturas, 'codigo').map((item, i) => (
                    <p
                      className={`${styles['area100']} ${styles['txtcobertura_item']}`}
                      key={i}
                    >
                      <span className={styles['area75']}>{item.descripcion} </span>
                      <span className={styles['area25']}>{item.monto.toLocaleString('en-US', {minimumFractionDigits : 2})}</span>
                    </p>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default ProductoCard
